var React = require('react');

function PrevnextInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.96 14V8.68L14 14V2L4.96 7.33V2H2v12z","fill":"currentColor","fillRule":"nonzero"}));
}

PrevnextInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = PrevnextInline;

PrevnextInline.default = PrevnextInline;
